import { Expose, Type } from "class-transformer";

export class PhotoModel {
  url: string = "";
  fileName: string = "";
}

export class ResolutionLogModel {
  logId: number = 0;
  statusId: number = 0;
  statusName: string = "";
  supportRequestedFrom: string = "";
  solution: string = "";
  actionTaken: string = "";
  resolvedDate: string = "";
  resolvedBy: string = "";
  @Type(() => PhotoModel)
  photosBefore: PhotoModel[] = [];
  @Type(() => PhotoModel)
  photosAfter: PhotoModel[] = [];
}

export class ProblemModel {
  problemId: number = 0;
  subShopTypeId: number = 0;
  subShopTypeName: string = "";
  // ticketId: number = 0;
  customerCode: string = "";
  customerName: string = "";
  problemGroupId: number = 0;
  problemGroupName: string = "";
  problemGroupCode: string = "";
  problemTypeId: number = 0;
  problemTypeName: string = "";
  statusId: number = 0;
  statusName: string = "";
  reportDate: string = "";
  reportBy: string = "";
  problemDetail: string = "";
  businessImpact: string = "";
  impactValue: number = 0;
  duration: string = "";
  updatedDate: string | null = null;
  message?: string | null = null;
  isViewOnly: boolean = false;
  isApprove: boolean = false;
  @Type(() => ResolutionLogModel)
  resolutionLogs: ResolutionLogModel[] = [];
}

export class ChannelModel {
  channelId: number = 0;
  channelName: string = "";
}

export class StatusModel {
  statusId: number = 0;
  statusName: string = "";
}

export class ProblemGroupModel {
  problemGroupId: number = 0;
  problemGroupName: string = "";
}

export class ProblemTypeModel {
  problemTypeId: number = 0;
  problemTypeName: string = "";
}

export class CustomerWithProblemModel {
  customerId: number = 0;
  customerCode: string = "";
  customerName: string = "";
  total: number = 0;
  pending: number = 0;
  followUp: number = 0;
  resolved: number = 0;
  informOnly: number = 0;
  pendingCloseApproval: number = 0;
}

export class ProblemTrackingCustomerModel {
  customerCode: string = "";
  customerName: string = "";
}

export class ProblemByCustomerModel {
  isOwnCustomer: boolean = false;
  @Type(() => ProblemModel)
  items: ProblemModel[] = [];
}
